/* eslint-disable @typescript-eslint/consistent-type-definitions */
import * as React from 'react';
const PanelContext = React.createContext({});
export default PanelContext;
